/**
 * Korean particles that depend on the last syllable ("카카오맵은" vs "쿠팡이츠는").
 * Non-Hangul endings (Latin names like "Google Play") are read by how they are usually
 * pronounced: a final consonant letter except a few vowel-like ones.
 */
type Pair = "은/는" | "이/가" | "을/를" | "과/와" | "으로/로";

function hasBatchim(word: string): { batchim: boolean; rieul: boolean } {
  const last = word.trim().slice(-1);
  const code = last.charCodeAt(0);
  if (code >= 0xac00 && code <= 0xd7a3) {
    const jong = (code - 0xac00) % 28;
    return { batchim: jong !== 0, rieul: jong === 8 };
  }
  if (/[0-9]/.test(last)) return { batchim: "013678".includes(last), rieul: "178".includes(last) };
  const l = last.toLowerCase();
  if (/[a-z]/.test(l)) return { batchim: /[lmnrkpt]/.test(l), rieul: /[lr]/.test(l) };
  return { batchim: false, rieul: false };
}

export function josa(word: string, pair: Pair): string {
  const { batchim, rieul } = hasBatchim(word);
  const [withB, withoutB] = pair.split("/") as [string, string];
  if (pair === "으로/로") return word + (batchim && !rieul ? withB : withoutB);
  return word + (batchim ? withB : withoutB);
}
